import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';

/* eslint-disable no-param-reassign */

/**
 * Assigns the value from a callback ref to provided ref objects or passes the value to provided callback refs.
 * @param refs - A list of ref objects and/or ref callbacks to be assigned/called where each ref is an individual argument.
 */
function mergeRefs() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (value) {
    _forEachInstanceProperty(refs).call(refs, function (ref) {
      if (typeof ref === 'function') {
        // Handles a callback ref
        ref(value);
      } else if (ref) {
        try {
          ref.current = value;
        } catch (error) {
          var _context, _context2;

          throw new Error(_concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "Cannot assign value \"".concat(value, "\" to ref \"")).call(_context2, ref, "\": ")).call(_context, error));
        }
      }
    });
  };
}

export { mergeRefs as default };
